module.exports = __webpack_public_path__ + "static/media/scroll02_0.29a4266d.png";